import React from "react";

const features = [
  {
    icon: "fa-headset",
    title: "Business Helpline",
    desc: "Instant guidance on compliance, licenses, GST, hiring and more — one call away.",
    color: "from-emerald-500 to-emerald-400",
  },
  {
    icon: "fa-people-group",
    title: "Community",
    desc: "An active circle of founders, MSMEs and mentors solving real problems together.",
    color: "from-orange-500 to-amber-400",
    link: "https://chat.whatsapp.com/LxXQ83O3fe92mLDKmN6N0S",
  },
  {
    icon: "fa-user-tie",
    title: "Expert Advisory",
    desc: "Vetted CAs, lawyers, growth strategists and CXOs to guide every key decision.",
    color: "from-blue-500 to-indigo-500",
  },
  {
    icon: "fa-tower-broadcast",
    title: "Media Platform",
    desc: "Get featured, share your story and amplify reach through IBH's media network.",
    color: "from-fuchsia-500 to-purple-500",
  },
];

const About = () => {
  return (
    <section
      id="about"
      className="py-20 sm:py-28 relative"
      data-testid="about-section"
    >
      <div className="section">
        <div className="max-w-2xl ">
   <span className="chip w-fit" style={{display: "inline-flex", alignItems: "center", gap: "-4px", paddingLeft: "5px"}} data-testid="about-eyebrow">
  <i className="fa-solid fa-sparkles text-ibh-orange"></i>
  About IBH
</span>
          <h2 className="mt-4 font-display text-3xl sm:text-5xl font-bold text-slate-900 leading-tight ">
            Simplifying <span className="gradient-text">Business Journeys</span>
          </h2>
          <p className="mt-5 text-lg text-slate-600">
            IBH brings together the four pillars every Indian business needs —
            so you can stop juggling consultants and start scaling.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f, idx) => (
            <div
              key={f.title}
              className="group relative rounded-3xl bg-white border border-slate-200/70 p-6 card-hover overflow-hidden"
              data-testid={`about-card-${idx}`}
            >
              <div
                className={`absolute -top-12 -right-12 h-40 w-40 rounded-full bg-gradient-to-br ${f.color} opacity-0 group-hover:opacity-20 blur-2xl transition-opacity duration-500`}
              ></div>
              <div
                className={`h-12 w-12 rounded-2xl bg-gradient-to-br ${f.color} flex items-center justify-center text-white shadow-soft`}
              >
                <i className={`fa-solid ${f.icon}`}></i>
              </div>
              <p className="mt-5 font-display font-bold text-lg text-slate-900">
  {f.title}
</p>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                {f.desc}
              </p>
              
                {f.title === "Community" && (
                <a
                  href={f.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-5 flex items-center gap-2 text-sm font-semibold text-slate-900  transition-opacity"
                >
                  Learn more <i className="fa-solid fa-arrow-right text-xs"></i>
                </a>

              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
